import { initialListPaginationMeta } from "utils/helpers/pagination";

import { FloorTypeForm, FloorTypeState } from "../types";

export const initialForm: FloorTypeForm = {
  number: "",
  floorTypeName: "",
};

export const initialFloorTypeMeta = initialListPaginationMeta;

export const initialState: FloorTypeState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialFloorTypeMeta,
  error: null,
  isAddModalOpen: false,
  form: initialForm,
};
